export default "__VITE_ASSET__DqsPtpQH__"